import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Checkbox } from '../../ui/checkbox';
import { Button } from '../../ui/button';
import { DeliveryAddressFields } from '../../tax/DeliveryAddressFields';
import { API, auth } from './invoiceApi';

const BillingFields = ({ value, onChange }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div data-testid="inv-billing">
      <h3 className="text-sm font-semibold text-neutral-700 mb-2">Billing Address</h3>
      <div className="grid grid-cols-4 gap-3">
        <Input className="col-span-4" placeholder="Street address" value={value.street} onChange={set('street')} data-testid="inv-billing-street" />
        <Input className="col-span-2" placeholder="City" value={value.city} onChange={set('city')} data-testid="inv-billing-city" />
        <Input placeholder="State" value={value.state} onChange={set('state')} data-testid="inv-billing-state" />
        <Input placeholder="ZIP" value={value.zip} onChange={set('zip')} data-testid="inv-billing-zip" />
      </div>
    </div>
  );
};

const pickAddr = (a) => ({ street: a?.street || '', city: a?.city || '', state: a?.state || '', zip: a?.zip_code || a?.zip || '' });

export const CustomerSection = ({ form, set, token }) => {
  const [customers, setCustomers] = useState([]);
  useEffect(() => { axios.get(`${API}/admin/customers`, auth(token)).then((r) => setCustomers(r.data)).catch(() => {}); }, [token]);
  const choose = (id) => {
    const c = customers.find((x) => x.id === id);
    if (!c) return set({ customer_id: null });
    set({ customer_id: c.id, save_as_customer: false, customer_name: c.display_name || c.primary_contact || '', customer_email: c.email || '',
      customer_phone: c.work_phone || c.mobile_phone || '', company_name: c.company_name || '', billing_address: pickAddr(c.billing_address),
      delivery_address: pickAddr(c.shipping_address), payment_terms: c.payment_terms || form.payment_terms });
  };
  const field = (k, label, type = 'text') => (
    <div><Label className="text-xs">{label}</Label><Input type={type} value={form[k]} onChange={(e) => set({ [k]: e.target.value })} className="mt-1" data-testid={`inv-${k}`} /></div>
  );
  return (
    <section className="space-y-4" data-testid="inv-customer-section">
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex-1 min-w-[220px]"><Label className="text-xs">Customer</Label>
          <select value={form.customer_id || ''} onChange={(e) => choose(e.target.value)} className="w-full mt-1 px-3 py-2 border rounded-md text-sm" data-testid="inv-customer-select">
            <option value="">New customer (type details below)</option>
            {customers.map((c) => <option key={c.id} value={c.id}>{c.display_name || c.primary_contact} {c.company_name ? `· ${c.company_name}` : ''} {c.email ? `· ${c.email}` : ''}</option>)}
          </select></div>
        {!form.customer_id && <label className="flex items-center gap-2 text-sm pb-2"><Checkbox checked={form.save_as_customer} onCheckedChange={(v) => set({ save_as_customer: !!v })} data-testid="inv-save-customer" /> Save as a new customer</label>}
      </div>
      <div className="grid sm:grid-cols-2 gap-3">{field('customer_name', 'Customer name *')}{field('customer_email', 'Email', 'email')}{field('customer_phone', 'Phone', 'tel')}{field('company_name', 'Company')}</div>
      <BillingFields value={form.billing_address} onChange={(v) => set({ billing_address: v })} />
      <div>
        <DeliveryAddressFields value={form.delivery_address} onChange={(v) => set({ delivery_address: v })} testId="inv-delivery" />
        <Button type="button" variant="ghost" size="sm" className="mt-1 px-0 text-xs" onClick={() => set({ delivery_address: { ...form.billing_address } })} data-testid="inv-delivery-same">Same as billing address</Button>
      </div>
    </section>
  );
};
